if (!customElements.get("get-notify-products")) {
  class GetNotifyGroducts extends HTMLElement {
    constructor() {
      super();
      this.eachFormEl = this.querySelector(".get-notify-products__popup-form");
      this.popupOpenBtn = this.querySelector(".get-notify-button");
      this.notifyPopupForm = this.querySelector(".get-notify-products__popup");
      this.dropdownButton = this.querySelector("#dropdownButton");
      this.dropdownContent = this.querySelector(".get-notify-products__dropdown-content");
      this.nofityPopupCloseBtn = this.querySelector(".get-notify-products__popup-close-btn");
      this.noProductsErrorMsg = this.querySelector(".popup-no-products-error-msg");
      this.thankyouPopup = this.querySelector(".get-notify-products__thank-you-popup");
      this.signupFormContent = this.querySelector(".get-notify-products__signup-form");
      this.formSubmitBtn = this.querySelector(".get-notify-products__submit-btn");
      this.isSelectProductsEnable = this.dataset.enableSelectProducts
      let formActionUrl;

      if (this.isSelectProductsEnable === "true") {
        formActionUrl = "https://script.google.com/macros/s/AKfycbxmv-ie4JOo2M-tdDribwkQFaLOctmEz9qffU9Go-qpZZIYyfef-kC6VE_5RhuV6J3z/exec";
      } else {
        formActionUrl = "https://script.google.com/macros/s/AKfycbxrAsRgtYUVCz8a53zG9DAGtmXeBlGSzSGpfiVRVd2M8-dyN_OzZrBetDcy10K5Hry4dQ/exec";
      }

      this.popupOpenBtn.addEventListener("click", this.openNotifyFormPopup.bind(this));
      this.nofityPopupCloseBtn.addEventListener("click", this.closeNotifyFormPopup.bind(this));

      this.dropdownButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dropdownContent.classList.toggle('active');
      });

      document.addEventListener('click', (event) => {
        if (!this.dropdownButton.contains(event.target) && !this.dropdownContent.contains(event.target)) {
          this.dropdownContent.classList.remove('active');
        }
      });

      // Listen for checkbox changes to update the dropdown button text
      this.eachFormEl.querySelectorAll("input[name='Products']").forEach((checkbox) => {
        checkbox.addEventListener('change', this.updateDropdownButtonText.bind(this));
      });

      this.eachFormEl.addEventListener("submit", (e) => {
        e.preventDefault();
        const formData = new FormData();
        const phoneNumber = this.querySelector("#get-notify-form-mobile-number");
        const email = this.querySelector("#get-notify-form-email");
        const name = this.querySelector("#get-notify-form-name");

        // Get the current time in the format HH:mm:ss
        const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });

        // Gather all selected products and append each one separately
        const selectedProducts = this.eachFormEl.querySelectorAll("input[name='Products']:checked");
        let selectedProductsNames = "";
        selectedProducts.forEach((checkbox) => {
          if (selectedProductsNames === "") {
            selectedProductsNames = `${selectedProductsNames} ` + checkbox.value;
          } else {
            selectedProductsNames = `${selectedProductsNames} , ` + checkbox.value;
          }
        });

        formData.append('Name', name.value.trim());
        formData.append('Email', email.value);
        formData.append('Phone Number', phoneNumber.value);
        formData.append('Products', selectedProductsNames);
        formData.append('Time', currentTime);

        this.formSubmitBtn.classList.add("loading")
        fetch(formActionUrl, {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (response.ok) {
              this.noProductsErrorMsg.innerHTML = "";
              this.dropdownButton.textContent = 'Select Products';
              this.eachFormEl.reset();
              this.thankyouPopup.classList.add("active")
              this.signupFormContent.classList.remove("active")
              setTimeout(() => {
                this.closeNotifyFormPopup()
              }, 3000)
            } else {
              throw new Error("Network response was not ok " + response.statusText);
            }
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
            this.formSubmitBtn.classList.remove("loading")
          });
      });
    }

    // Update the dropdown button text based on selected products
    updateDropdownButtonText() {
      const selectedProducts = this.eachFormEl.querySelectorAll("input[name='Products']:checked");
      const selectedProductTitles = Array.from(selectedProducts).map(checkbox => checkbox.value);

      if (selectedProductTitles.length > 0) {
        this.dropdownButton.textContent = selectedProductTitles.join(', ');
      } else {
        this.dropdownButton.textContent = 'Select Products';
      }
    }

    openNotifyFormPopup() {
      this.eachFormEl.reset();
      this.dropdownButton.innerHTML = 'Select Products';
      this.notifyPopupForm.classList.add("active");
      document.body.style.overflow = "hidden";
      this.signupFormContent.classList.add("active")
      this.thankyouPopup.classList.remove("active")
    }

    closeNotifyFormPopup() {
      this.notifyPopupForm.classList.remove("active");
      document.body.style.overflow = "unset";
    }
  }

  customElements.define("get-notify-products", GetNotifyGroducts);
}